import * as tslib_1 from "tslib";
import setCategory from '../mutators/setCategory';
import setSubCategoryState from '../mutators/setSubCategoryState';
import getCurrentSubcategory from '../selectors/getCurrentSubcategory';
import getCurrentSubcategoryLoadState from '../selectors/getCurrentSubcategoryLoadState';
export default function updateCategory(categoryKey, subcategoryKey, currentOptionKey) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var subCategory, success, e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setCategory(categoryKey, subcategoryKey, currentOptionKey);
                    subCategory = getCurrentSubcategory();
                    if (!(getCurrentSubcategoryLoadState() === 1 /* Loaded */ ||
                        getCurrentSubcategoryLoadState() === 0 /* Loading */)) return [3 /*break*/, 1];
                    return [2 /*return*/];
                case 1:
                    if (!subCategory.onSelected) return [3 /*break*/, 6];
                    setSubCategoryState(subCategory, 0 /* Loading */);
                    success = void 0;
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, subCategory.onSelected()];
                case 3:
                    success = _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    success = false;
                    return [3 /*break*/, 5];
                case 5:
                    setSubCategoryState(subCategory, success ? 1 /* Loaded */ : 2 /* Error */);
                    return [3 /*break*/, 7];
                case 6:
                    setSubCategoryState(subCategory, 1 /* Loaded */);
                    _a.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=updateCategory.js.map